var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      attrs: { id: _vm.user.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("users.show") || _vm.$_can("users.view-own")
        }
      }
    },
    [
      _vm.userLoading
        ? [_vm._m(0)]
        : [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "UsersEdit",
                    params: { id: "" + _vm.user.id },
                    query: {
                      data:
                        "" + (_vm.q ? "?q=" + encodeURIComponent(_vm.q) : "")
                    }
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex list-box-header col-12 pointer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pl-0 list-box-header-left col-lg-9 col-6 pr-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pl-0 d-flex align-items-center col-lg-4 col-7"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "list-box-status align-items-start col-xl-3 col-lg-4 col-5"
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _c("span", { staticClass: "ref-id" }, [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "32",
                                          height: "32",
                                          viewBox: "0 0 32 32",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M16 0C7.168 0 0 7.168 0 16C0 24.832 7.168 32 16 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 16 0ZM16 4.8C18.656 4.8 20.8 6.944 20.8 9.6C20.8 12.256 18.656 14.4 16 14.4C13.344 14.4 11.2 12.256 11.2 9.6C11.2 6.944 13.344 4.8 16 4.8ZM16 27.52C12 27.52 8.464 25.472 6.4 22.368C6.448 19.184 12.8 17.44 16 17.44C19.184 17.44 25.552 19.184 25.6 22.368C23.536 25.472 20 27.52 16 27.52Z",
                                            fill: "#E4E8EC"
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "claim-customer col-12 pl-1 wrap"
                              },
                              [
                                _c("span", { staticClass: "full-name" }, [
                                  _vm._v(
                                    _vm._s(_vm.user.first_name) +
                                      " " +
                                      _vm._s(_vm.user.last_name)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.user.username) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center mobilehide col-7 wrap"
                          },
                          [
                            _vm.user.roles
                              ? _c(
                                  "div",
                                  { staticClass: "user-roles" },
                                  _vm._l(_vm.user.roles, function(role) {
                                    return _c("div", { key: role.id }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pr-2",
                                          class: role.department
                                            ? [
                                                role.department.id === 4
                                                  ? "dispatch-roles "
                                                  : "",
                                                role.department.id === 2
                                                  ? "sales-roles "
                                                  : "",
                                                role.department.id === 3
                                                  ? "claims-roles "
                                                  : "",
                                                role.department.id === 1
                                                  ? "management "
                                                  : ""
                                              ]
                                            : ""
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(role.name) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ])
                                  })
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "list-box-header-right col-lg-3 col-6 pl-4"
                      },
                      [
                        _c("label"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center col-3 col-lg-5 wrap"
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-circle",
                              class: [
                                _vm.user.user_status.name === "Active"
                                  ? "active"
                                  : "inactive"
                              ]
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.user.user_status.name) +
                                  "\n            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "list-box-header-options justify-content-end col-9 col-xl-7 col-lg-8 pointer"
                          },
                          [
                            _c("div", { staticClass: "options pl-4" }, [
                              _vm.$_can("clusters.users.update")
                                ? _c(
                                    "div",
                                    { staticClass: "options-buttons" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                            }
                                          }
                                        },
                                        [
                                          _c("button", {
                                            staticClass:
                                              "btn btn-secondary add-filter",
                                            attrs: {
                                              type: "button",
                                              id: "dropdownMenuButton",
                                              "data-toggle": "dropdown",
                                              "aria-haspopup": "true",
                                              "aria-expanded": "false"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: {
                                                "aria-labelledby":
                                                  "dropdownMenuButton"
                                              }
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click:
                                                      _vm.openUserStatusModal
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Change user status\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-secondary expand-claims",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              _vm.toggleUser(_vm.user.id)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-caret-down caret",
                                            class: {
                                              rotate: _vm.expanded.includes(
                                                _vm.user.id
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              class: [
                _vm.expanded.includes(_vm.user.id) ? "w-100 divider" : "hidden"
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column",
                class: [
                  _vm.expanded.includes(_vm.user.id)
                    ? "list-box-expanded"
                    : "hidden"
                ]
              },
              [
                _c("div", { staticClass: "d-flex col-12 p-0" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start col-lg-3 col-6"
                    },
                    [
                      _c("div", { staticClass: "contact-info mb-4" }, [
                        _c("span", { staticClass: "claim-heading pb-2" }, [
                          _vm._v("\n              Email\n            ")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "email" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.user.email) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "claim-heading pt-4 pb-2" }, [
                          _vm._v("\n              Phone\n            ")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "email" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.phoneMask.maskedPhone(_vm.user.phone)
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start col-lg-9 col-6"
                    },
                    [
                      _c("div", { staticClass: "contact-info mb-4" }, [
                        _c("span", { staticClass: "claim-heading pb-2" }, [
                          _vm._v("\n              Carriers\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.user.carriers
                          ? _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "div",
                                { staticClass: "row col-12" },
                                [
                                  _vm._l(_vm.user.carriers, function(
                                    carrier,
                                    index
                                  ) {
                                    return [
                                      _c("div", { key: index }, [
                                        index !== 0
                                          ? _c("span", [_vm._v(", ")])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(carrier.name) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  })
                                ],
                                2
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact-info mobileshow" }, [
                        _c("span", { staticClass: "claim-heading pb-2" }, [
                          _vm._v("\n              Roles\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.user.roles
                          ? _c(
                              "div",
                              { staticClass: "d-flex" },
                              _vm._l(_vm.user.roles, function(role) {
                                return _c("div", { key: role.id }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pr-2",
                                      class: [
                                        role.id === 27 || role.id === 28
                                          ? "dispatch-roles"
                                          : "",
                                        role.id === 30 || role.id === 31
                                          ? "sales-roles"
                                          : "",
                                        role.id === 25 || role.id === 26
                                          ? "claims-roles"
                                          : "",
                                        role.id === 1 ? "management" : ""
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(role.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              })
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.userStatusModal
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": true },
                    on: {
                      close: function($event) {
                        _vm.userStatusModal = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _c("div", [
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.user.user_status.name) +
                                  " - Change user status"
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Status")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: { options: _vm.userStatuses },
                              on: {
                                change: function($event) {
                                  _vm.clearError($event)
                                }
                              },
                              model: {
                                value: _vm.user.user_status_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "user_status_id", $$v)
                                },
                                expression: "user.user_status_id"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cluster_user_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              attrs: { type: "button" },
                              on: { click: _vm.changeStatus }
                            },
                            [_vm._v("\n              Confirm\n            ")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis px-4 py-4" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-475153fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475153fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UsersBlock.vue
// module id = null
// module chunks = 